// components/PanelDivider.tsx
import React, { useState } from "react";

interface PanelDividerProps {
  onMouseDown: (e: React.MouseEvent) => void;
}

export const PanelDivider: React.FC<PanelDividerProps> = ({ onMouseDown }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      onMouseDown={onMouseDown}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="relative flex-shrink-0 flex items-center justify-center cursor-col-resize z-10 select-none nodrag nowheel px-1.5"
      style={{ width: 5 }}
      title="Drag to resize"
    >
      {/* Track line */}
      <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 transition-all duration-150 rounded-full" />
      {/* Grip dots */}
      <div className="absolute flex flex-col gap-[3px] pointer-events-none z-10">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className="block rounded-full"
            style={{
              width: 4,
              height: 4,
              background: hover
                ? "var(--muted-foreground, gray-400)"
                : "var(--light-gray, gray-400)",
            }}
          />
        ))}
      </div>
    </div>
  );
};
